import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const SalaryDeclaration = lazy(() => import('../../container/employee-salary/salary-declaration'));
const SalaryMonthDeclaration = lazy(() => import('../../container/employee-salary/salary-month-declaration'));
const MonthlySalary = lazy(() => import('../../container/employee-salary/monthly-salary'));
const SalaryIncrementMonthDeclaration = lazy(() => import('../../container/employee-salary/salary-increment-month-declaration'));
const providentFundEmployees = lazy(() => import('../../container/employee-salary/provident-fund-employees'));

const EmployeeSalaryRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/salaryDeclaration`} component={SalaryDeclaration}/>
            <Route path={`${path}/SalaryMonthDeclaration`} component={SalaryMonthDeclaration}/>
            <Route path={`${path}/MonthlySalary`} component={MonthlySalary}/>
            <Route path={`${path}/SalaryIncrementMonthDeclaration`} component={SalaryIncrementMonthDeclaration}/>
            <Route path={`${path}/providentFundEmployees`} component={providentFundEmployees}/>
        </Switch>
    );
};

export default EmployeeSalaryRoutes;